import { useState, useCallback } from 'react';
import SEO from '../../components/SEO';
import AdUnit from '../../components/AdUnit';

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
}

function UuidGenerator() {
  const [uuids, setUuids] = useState([generateUUID()]);
  const [count, setCount] = useState(1);
  const [uppercase, setUppercase] = useState(false);
  const [noDashes, setNoDashes] = useState(false);
  const [copied, setCopied] = useState(false);

  var generate = useCallback(function () {
    var list = [];
    for (var i = 0; i < Math.min(count, 100); i++) { list.push(generateUUID()); }
    setUuids(list);
  }, [count]);

  var formatted = uuids.map(function (u) {
    var r = noDashes ? u.replace(/-/g, '') : u;
    return uppercase ? r.toUpperCase() : r;
  });

  var copy = useCallback(function () {
    navigator.clipboard.writeText(formatted.join('\n')).then(function () { setCopied(true); setTimeout(function () { setCopied(false); }, 2000); });
  }, [formatted]);

  return (
    <div className="page-prettifier">
      <SEO title="UUID Generator - Generate Random UUIDs Online" description="Free online UUID v4 generator. Generate one or multiple random UUIDs instantly. Copy with one click." path="/uuid-generator" />
      <div className="container">
        <div className="tool-header">
          <h1>UUID Generator</h1>
          <p>Generate random universally unique identifiers (UUID v4) instantly.</p>
        </div>
        <AdUnit />
        <div className="toolbar">
          <div className="toolbar-left">
            <label htmlFor="uuid-count" className="indent-label">Count:</label>
            <input id="uuid-count" type="number" min="1" max="100" value={count} onChange={function (e) { setCount(parseInt(e.target.value) || 1); }} className="indent-select" style={{ width: '70px' }} />
            <label className="checkbox-label"><input type="checkbox" checked={uppercase} onChange={function (e) { setUppercase(e.target.checked); }} /> Uppercase</label>
            <label className="checkbox-label"><input type="checkbox" checked={noDashes} onChange={function (e) { setNoDashes(e.target.checked); }} /> No dashes</label>
          </div>
          <div className="toolbar-right">
            <button onClick={generate} className="btn btn-primary" type="button">Generate</button>
            <button onClick={copy} className="btn btn-accent" type="button">{copied ? '✓ Copied' : 'Copy All'}</button>
          </div>
        </div>
        <div className="editor-pane" style={{ marginTop: '1rem' }}>
          <div className="pane-header"><span>Generated UUIDs</span><span className="char-count">{formatted.length} uuid(s)</span></div>
          <textarea className="editor-textarea output-textarea" value={formatted.join('\n')} readOnly spellCheck={false} aria-label="Generated UUIDs" style={{ minHeight: '200px' }} />
        </div>
        <section className="tool-guide">
          <h2>What is a UUID?</h2>
          <p>A UUID (Universally Unique Identifier) is a 128-bit number used to identify things in computer systems. They are designed to be unique across time and space, so you can generate them independently without worrying about duplicates. UUIDs are used in databases, APIs, file systems, and many other places where you need a unique ID.</p>
        </section>
      </div>
    </div>
  );
}

export default UuidGenerator;
